import { DateRangePicker as BaseDateRangePicker } from "@mui/x-date-pickers-pro";
import { SingleInputDateRangeField } from "./SingleInputDateRangeField.tsx";
import { createTheme } from "@mui/material";
import { fontStack } from "src/lib/emotion/utils.ts";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import type { DateRangePickerProps as MuiDateRangePickerProps } from "@mui/x-date-pickers-pro";
import React from "react";

const muiTheme = createTheme({
  typography: {
    fontFamily: fontStack(["Poppins", "sans-serif"]),
  },
});

export type DateRangePickerProps = MuiDateRangePickerProps<any>;

export const DateRangePicker = (props: DateRangePickerProps) => {
  const {
    slots: { field: fieldSlot = SingleInputDateRangeField, ...restSlots } = {},
    ...restProps
  } = props;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <BaseDateRangePicker
        slots={{
          field: fieldSlot,
          ...restSlots,
        }}
        {...restProps}
      />
    </MuiThemeProvider>
  );
};
